// Google Sheets API 서비스 (Google Apps Script 웹앱 사용)

interface RSVPData {
  name: string;
  attendance: string;
  guests: string;
  message?: string; // optional: 메시지 필드는 선택사항
}

export const saveToGoogleSheets = async (data: RSVPData): Promise<void> => {
  const scriptUrl = process.env.REACT_APP_GOOGLE_SCRIPT_URL;

  console.log('🔧 [GoogleSheets] 환경변수 확인:');
  console.log('  - REACT_APP_GOOGLE_SCRIPT_URL:', scriptUrl);
  console.log('  - URL 존재 여부:', !!scriptUrl);

  if (!scriptUrl) {
    console.error('❌ [GoogleSheets] Google Script URL이 설정되지 않았습니다.');
    throw new Error('Google Script URL이 설정되지 않았습니다. Vercel 환경변수를 확인해주세요.');
  }

  console.log('📤 [GoogleSheets] 데이터 전송 시작:', data);

  try {
    const response = await fetch(scriptUrl, {
      method: 'POST',
      mode: 'no-cors', // Google Apps Script는 CORS를 지원하지 않으므로 no-cors 모드 사용
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: data.name,
        attendance: data.attendance,
        guests: data.guests,
        message: data.message || '', // 메시지가 없으면 빈 문자열
        timestamp: new Date().toISOString()
      })
    });

    console.log('✅ [GoogleSheets] 응답 받음:', response);
    console.log('  - Response type:', response.type);
    console.log('  - Response status:', response.status);

    // no-cors 모드에서는 응답을 읽을 수 없지만, 요청이 성공하면 Google Sheets에 저장됨
    console.log('✅ [GoogleSheets] Google Sheets에 저장 완료');

  } catch (error) {
    console.error('❌ [GoogleSheets] 저장 실패:', error);
    console.error('  - Error message:', (error as Error).message);
    console.error('  - Error stack:', (error as Error).stack);
    throw new Error('데이터 저장에 실패했습니다. 콘솔을 확인해주세요.');
  }
};
